import {SING_UP,LOG_IN,LOG_OUT} from './authAction';
import {REMOVE_FOLLOW,ADD_TO_FOLLOW} from '../store/actions'
const initialState = {
  id:null,
  email:null,
  postion:null,
  job:null,
  hobby:null,
  follwers:null,
  follow:null,
  photo:null,
  bio:null,
  name:null,
  age:0,
  story:null,
  pid:null,
  big_img:null,
  password:null
}
export default (state=initialState,action) =>{
  switch (action.type) {
    case SING_UP:
      return{
        ...state,
        id:action.id,
        pid:action.pid || action.id
      }
      case ADD_TO_FOLLOW:
        return{
          ...state,
          follow: Math.max(0, (Number(state.follow) || 0) + (action.wasFollowing ? -1 : 1))
        }
      case REMOVE_FOLLOW:
        return{
          ...state,follow: Math.max(0, (Number(state.follow) || 0) - 1)
        }
      case LOG_OUT:
        return{
          ...initialState
        }
      case LOG_IN:
        return{
          id:action.id,
          email:action.userData.email,
          postion:action.userData.postion,
          job:action.userData.job,
          hobby:action.userData.hobby,
          photo:action.userData.photo,
          follow:action.userData.follow,
          followers:action.userData.followers,
          bio:action.userData.bio,
          name:action.userData.name,
          age:action.userData.age,
          story:action.userData.story,
          big_img:action.userData.big_img,
          password:action.userData.password,
          pid:action.pid
        }
  }
  return state;
}
